import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getOdontoSpecialties} from '../../services/getOdontoSpecialties';

function useGetOdontoSpecialtiesQuery() {
	return useQuery({
		queryKey: [QUERY_KEYS.ODONTO_SPECIALTIES],
		queryFn: async ({signal}) => getOdontoSpecialties({signal}),
		retry: 1,
	});
}

export {useGetOdontoSpecialtiesQuery};
